import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiAxisSide, BiSeriesType } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { BiChip } from '../../../components/ui/BiChip';

const kTypes: Array<{ value: BiSeriesType; label: string }> = [
  { value: BiSeriesType.Bar, label: '柱形' },
  { value: BiSeriesType.Line, label: '折线' },
  { value: BiSeriesType.Area, label: '面积' },
];

/** One charted measure: how it is drawn and on which axis. */
export const SeriesRow = memo(
  ({
    name,
    type,
    axis,
    canGoRight,
    withAxis,
    onType,
    onAxis,
  }: {
    name: string;
    type: BiSeriesType;
    axis: BiAxisSide;
    /** Moving it right would leave no series on the left, or stack it. */
    canGoRight: boolean;
    /** A `seriesBy` split keeps every series on the left. */
    withAxis: boolean;
    onType: (type: BiSeriesType) => void;
    onAxis: (axis: BiAxisSide) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(6) }}>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.foreground}
          numberOfLines={1}
        >
          {name}
        </Typography.Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(6) }}>
          {kTypes.map(option => (
            <BiChip
              key={option.value}
              label={option.label}
              selected={type === option.value}
              onPress={() => onType(option.value)}
            />
          ))}
          {withAxis ? (
            <>
              <View style={{ width: rpx(8) }} />
              <BiChip
                label="左轴"
                selected={axis === BiAxisSide.Left}
                onPress={() => onAxis(BiAxisSide.Left)}
              />
              <BiChip
                label="右轴"
                selected={axis === BiAxisSide.Right}
                disabled={axis !== BiAxisSide.Right && !canGoRight}
                onPress={() => onAxis(BiAxisSide.Right)}
              />
            </>
          ) : null}
        </View>
      </View>
    );
  },
);
